import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from "./App";
import reportWebVitals from './reportWebVitals';
import {LayoutProvider} from "./Primereact/layout/context/LayoutContext";
import {PrimeReactProvider} from "primereact/api";
import "primeflex/primeflex.css";
import "primeicons/primeicons.css";
import "primereact/resources/primereact.css";
import "./Primereact/styles/demo/Demos.scss";
import "./Primereact/styles/layout/layout.scss";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import {HelmetProvider} from "react-helmet-async";
import {AuthProvider} from "./hooks/useAuth";
import '@fortawesome/fontawesome-free/css/all.min.css';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
    <React.StrictMode>
        <PrimeReactProvider>
            <AuthProvider>
                <HelmetProvider>
                    <LayoutProvider>
                        <App/>
                    </LayoutProvider>
                </HelmetProvider>
            </AuthProvider>
        </PrimeReactProvider>
    </React.StrictMode>
);

serviceWorkerRegistration.register();
reportWebVitals();